import { useTypedParams } from '@sorare/routing';

import { SquadJoin } from '#src/components/squad/SquadJoin/index.tsx';

import type { PageParams } from './__generated__/routeParams.ts';

const SquadJoinCodePage = () => {
  const { code } = useTypedParams<PageParams>();
  return <SquadJoin code={code} />;
};
export default SquadJoinCodePage;
